import { AppService } from "app/services/app.service";

import { ConfigModulos } from "app/models/configmodulos.model";
import { Observable } from "rxjs";

export abstract class AbConfigModulos extends AppService {
  abstract getConfigModulos(): Observable<any>;
  abstract saveConfigModulos(configModulos: ConfigModulos): Observable<any>;
  abstract getConfigModulosStorage(): ConfigModulos;
  abstract saveConfigModulosStorage(configModulos: ConfigModulos);
}